export const getLinkWithParams = (link: string): string => {
   const urlParams = new URLSearchParams(window.location.search);
   return `${link}?${urlParams.toString()}`;
};
